import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import g1 from '../../../Images/g1.jpg';
import g2 from '../../../Images/g2.jpg';
import g3 from '../../../Images/g3.jpg';
import g4 from '../../../Images/g4.jpg';
import g5 from '../../../Images/g5.jpg';
import './Gallery.css';


const Gallery = () => {
    return (
        <section className="gallery-wrapper text-white" id='gall'>
            <Container>

                <Row>
                    <Col sm={12} className="text-center">
                        <div className="section-title">
                            <h1>Our Doctors</h1>
                        </div>
                    </Col>
                </Row>


                <Row>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2> GENERAL SURGEON  </h2>
                                <p><b className='doctors'>Dr. P.C. Tiwari </b><br />
                                    M.B.B.S , M.S , <br />( General Surgeon)
                                    ON CALL
                                </p>
                                <p> <b className='doctors'>Dr. Vivek Kumar Singh</b><br />
                                    M.S. (General Surgeon)
                                    ON CALL
                                </p>
                                <p> <b className='doctors'>Dr.  S.K Gupta </b>  <br />
                                    M.S. , (Surgeon)
                                    ON CALL
                                </p>
                                <p> <b className='doctors'>Dr. Abhishek Suryavanshi </b><br />
                                    M.S., (General Surgeon)
                                    ON CALL
                                </p>
                            </div>
                        </div>
                    </Col>


                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>GYNAECOLOGIST   </h2>
                                <p> <b className='doctors'>Dr. Samta Pandey </b> <br />M.S. (Gynae + Obs) <br />
                                    OPD Timings- 1 Pm to 3 pm
                                </p>
                                <p> <b className='doctors'>Dr. Rashmi Sharma </b> <br />
                                    M.B.B.S. D.G.O. ,  (Obs. , Gynae) <br />
                                    OPD Timings – 5 pm to 6 pm
                                </p>
                                <p> <b className='doctors'>Dr. Shikha Vinayak</b> <br />
                                    M.B.B.S. D.G.O. , ( Obs, Gynae )
                                    ON CALL
                                </p>
                            </div>
                        </div>
                    </Col>


                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>PEDIATRICIAN </h2>
                                <p> <b className='doctors'>Dr. Ravi Pandey </b><br />
                                    M.B.B.S. , M.D., (Pedia) <br />
                                    OPD Timings – 2 pm to 3 pm
                                </p>
                                <p> <b className='doctors'>Dr. Sunil Kanujiya </b><br />
                                    M.C.H., (Pedia Surgeon)
                                    ON CALL
                                </p>
                                <p> <b className='doctors'>Dr. D. Singh  </b><br />
                                    M.B.B.S. , D.C.H., (Pedia) <br />
                                    OPD Timings – 6 pm to 8 pm
                                </p>
                                <p> <b className='doctors'>Dr. Ayank Tandon </b> <br />
                                    M.B.B.S, M.D,
                                    ON CALL
                                </p>

                            </div>
                        </div>
                    </Col>


                    <Col md={6} lg={8} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>ORTHOPAEDIC </h2>
                                <p> <b className='doctors'>Dr. Siddhartha Tiwari</b> <br />
                                    M.B.B.S,  D.N.B,<br/> (Ortho &  Spine   Surgeon)
                                    ON CALL
                                </p>
                                <p> <b className='doctors'>Dr. Abhishek Pandey  </b><br />
                                    M.B.B.S, M.S, (Ortho) ON CALL
                                </p>
                                <p> <b className='doctors'>Dr. Madhu Sudan Mishra </b> <br /> M.B.B.S, M.S On Call</p>

                            </div>
                        </div>
                    </Col>







                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>ANAESTHESIA </h2>
                                <p> <b className='doctors'>Dr. B.S Negi  </b><br /> M.D., (Anaesthesia)  <br /> On Call</p>
                                <p> <b className='doctors'>Dr. Somnath Lohanvi  </b><br /> M.D., (Anaesthesia)</p>
                            </div>
                        </div>
                    </Col>


                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>CHEST SPECIALIST </h2>
                                <p> <b className='doctors'>Dr.  A.K.   Verma  </b> <br /> M.B.B.S., M.D. <br />(Chest Phy.)  <br />OPD Timings – 8 pm to 9 pm  </p>

                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>E.N.T. </h2>
                                <p> <b className='doctors'>Dr. R.K.  Mishra  </b><br /> M.S. (ENT Surgeon ) <br />On Call</p>

                            </div>
                        </div>
                    </Col>




                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>UROLOGIST </h2>
                                <p> <b className='doctors'> Dr.  Firoz  Khan </b> <br /> M.Ch (Urologist)<br />  On Call </p>

                            </div>
                        </div>
                    </Col>




                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>DENTAL </h2>
                                <p> <b className='doctors'>Dr. Neeta Suryavanshi </b> <br /> B.D.S (Dental Surgeon) <br />  OPD Timings- Sunday to Friday – 11am to 2pm </p>

                            </div>
                        </div>
                    </Col>



                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>GASTRO  </h2>
                                <p> <b className='doctors'> Dr. Anurag Mishra  </b> <br /> DM (Gastro)<br /> ON CALL</p>

                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>GENERAL PHYSICIAN  </h2>
                                <p> <b className='doctors'> Dr. S. Yadav  </b> <br />  M.D Physician<br /> OPD Timing- 5:30 pm to 8 pm</p>

                            </div>
                        </div>
                    </Col>


                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>RADIOLOGIST</h2>
                                <p> <b className='doctors'> Dr. Ajai Kumar Verma </b> <br />  M.B.B.S ,  D.M.R.D ,   (Radiologist)  Ex. CMO<br />  11am to 4 pm</p>

                            </div>
                        </div>
                    </Col>


                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>PATHOLOGIST</h2>
                                <p> <b className='doctors'> Dr. Siddhartha Gangwar </b> <br />  M.D. (Pathologist)<br /> </p>

                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>PLASTIC SURGEON</h2>
                                <p> <b className='doctors'> Dr. Pushpendra Kanujiya</b> <br />  M.B.B.S , M.S., M.Ch <br /> ON CALL</p>

                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>NEUROLOGY</h2>
                                <p> <b className='doctors'> Dr. A. Kumar</b> <br /> M.B.B.S , M.S., M.Ch <br /> ON CALL</p>

                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>NEPHROLOGIST</h2>
                                <p> <b className='doctors'> Dr. Col. Kuldeep Singh</b> <br /> M.B.B.S , D.N.B<br /> </p>

                            </div>
                        </div>
                    </Col>

                    <Col md={6} lg={4} sm={12}>
                        <div className="single-item-box">
                            <div className="thumbnail">
                                <h2>OPHTHALMOLOGIST</h2>
                                <p> <b className='doctors'> Dr. S. K. TIWARI  </b> <br />  MBBS DOMS  EX CMO GORAKHPUR <br /> </p>

                            </div>
                        </div>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default Gallery;